/**
 * @generated SignedSource<<215b0940296c014942340277189a073f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRow_rules$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCellsConditionalFormatting_savedView_rules">;
  readonly " $fragmentType": "IssueRow_rules";
};
export type IssueRow_rules$key = {
  readonly " $data"?: IssueRow_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow_rules">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "IssueRow_rules",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useCellsConditionalFormatting_savedView_rules"
        }
      ]
    }
  ],
  "type": "JiraFormattingRuleConnection"
};

(node as any).hash = "e4507afd0584d23bc2b3f6adb1c45a91";

export default node;
